import { DefaultFacilityCardProps, FacilityCard } from '@gyym/ui'
import React from 'react'

export const FacilitySlide = ({
  ...cardProps
}: Omit<DefaultFacilityCardProps, 'variant'>) => {
  return <FacilityCard variant="default" {...cardProps} />
}
